import YogaCalendar from "../../../components/YogaCalendar";
import "../admin-base.css";
import "../admin-layout.css";
import "../admin-controls.css";
import "../admin-students.css";
import "../admin-misc.css";
import "../admin-responsive.css";

export default function CalendarTab() {
  return <div className="adm-tab-content adm-calendar-tab"><YogaCalendar initialAdminMode={true} hideAdminBtn={true} /></div>;
}